// @flow
/* eslint sort-keys: "error"*/

import type {SystemData} from '../../server/utils/systemData';

export type State = SystemData;
export type SiteFeatures = $PropertyType<SystemData, 'siteFeatures'>;

const initialState = {
    badBotPageSize: 10,
    brand: 'homeaway_us',
    brandId: '',
    cookie: '',
    currency: 'USD',
    directEntry: false,
    domainName: '',
    environment: 'development',
    facebook: {admins: '', appId: '', locale: 'en_US_HA'},
    fullLocale: 'en_US_HA',
    hasSortLegalDisclaimer: false,
    havId: '',
    hostname: '',
    isAndroid: false,
    isBadBot: false,
    isDesktop: false,
    isGoodBot: false,
    isIOS: false,
    isInternalUser: false,
    isMetric: false,
    isMobile: false,
    isTablet: false,
    locale: 'en-US',
    marketingOptInType: {sign_up: ''},
    referer: '',
    searchFilterCounts: true,
    siteFeatures: {
        hasMetricAreaUnit: false,
        hasSortLegalDisclaimer: false,
        showTotal: false
    },
    siteName: 'homeaway_us',
    theme: 'gt',
    transitionBanner: '',
    travelerApp: 'vrbo'
};

const identity = (state: State = initialState) => state;

export default identity;
